import { unref as m } from "vue";
function s(e, t = {}) {
  const { timeout: n = 500, scroll: l = { behavior: "smooth", block: "end" } } = t, o = m(e), r = o.$el ?? o;
  setTimeout(
    () => r?.scrollIntoView(l),
    // Give all children of componentOrElementRef time to compute
    // their dimensions, and time for the user to see the UI
    // stabilise before we scroll. This value is totally arbitrary.
    n
  );
}
export {
  s as scrollToElement
};
